import React from 'react';

const withModal = () => (WrappedComponent) => {
  const WithModal = (props) => {
    if (!props['isOpen']) return null;
    else return <WrappedComponent {...props} />;
  };
  return WithModal;
};

export default withModal;
